import { useCallback, useEffect, useRef, useState } from "react";
import { imgSrc } from "@/lib/api";

export const Intro = ({ c }) => (
  <div className="intro">
    <div><p className="label">{c.label}</p><h2>{c.title}</h2></div>
    {c.text && <p>{c.text}</p>}
  </div>
);

export const Lightbox = ({ item, onClose }) => {
  const x = useRef(null);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    x.current?.focus();
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k);
    return () => { document.body.style.overflow = ""; window.removeEventListener("keydown", k); };
  }, [onClose]);
  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label="Powiększone zdjęcie" onClick={(e) => e.target === e.currentTarget && onClose()} data-testid="lightbox">
      <button ref={x} className="close" type="button" onClick={onClose} aria-label="Zamknij" data-testid="lightbox-close-btn">×</button>
      <div><img src={imgSrc(item.image)} alt={item.alt} data-testid="lightbox-image" /><p>{[item.title, item.subtitle].filter(Boolean).join(" · ")}</p></div>
    </div>
  );
};

export const Gallery = ({ c }) => {
  const [open, setOpen] = useState(null);
  const close = useCallback(() => setOpen(null), []);
  return (
    <section id="realizacje" data-testid="gallery-section">
      <Intro c={c} />
      <div className="gallery" id="gallery">
        {c.items.map((it, i) =>
          it.image ? (
            <figure key={i} className={`shot${it.tall ? " tall" : ""}`}>
              <button type="button" onClick={() => setOpen(it)} aria-label={`Powiększ zdjęcie: ${it.title}`} data-testid={`gallery-item-${i}`}>
                <img src={imgSrc(it.image)} alt={it.alt} loading="lazy" style={{ objectPosition: it.position || "50% 50%" }} />
              </button>
              <figcaption><b>{it.title}</b>{it.subtitle}</figcaption>
            </figure>
          ) : (
            <div key={i} className={`shot empty${it.tall ? " tall" : ""}`} data-testid={`gallery-empty-${i}`}><p><b>{it.title}</b>{it.subtitle}</p></div>
          )
        )}
      </div>
      {open && <Lightbox item={open} onClose={close} />}
    </section>
  );
};
